import httpClient from '@/shared/http-tms-client';

const getOpenPermits = () => httpClient.get('/Permit/OpenPermits');
const getOPFeeList = () => httpClient.get(`/Registration/OperationalPermitFeeListAvailable`);
const getOPFeeByID = (registrationId) => httpClient.get(`/Registration/${registrationId}`);
// eslint-disable-next-line import/prefer-default-export
export {
  getOpenPermits,
  getOPFeeList,
  getOPFeeByID,
};
